import { useQuery } from "@tanstack/react-query";
import React from "react";
import Select from "react-select";
const EmployeeSelect = ({
  selectedEmployeeId,
  setSelectedEmployeeId,
  currentCompanyId,
  includeOptionForAll = false,
  placeholder = "Select an Employee",
  isDisabled = false,
}) => {
  const employeesQuery = useQuery({
    queryKey: [`company/${currentCompanyId}/users?take=10000`],
    staleTime: 60 * 1000,
  });
  let options = [];
  if (includeOptionForAll) {
    options.push({ _id: "all" });
  }
  let selectedEmployee = null;
  if (!employeesQuery.isLoading) {
    options.push(...employeesQuery.data);
    selectedEmployee = employeesQuery.data.find(
      (e) => e._id === selectedEmployeeId,
    );
  }
  return (
    <Select
      onChange={(value) => {
        setSelectedEmployeeId(value._id);
      }}
      options={options}
      placeholder={placeholder}
      isDisabled={isDisabled}
      styles={{
        control: (baseStyles) => ({
          ...baseStyles,
          // Set's the border color to match the Date Picker == 'snow-light-grey'
          borderColor: "#829399",
        }),
      }}
      value={selectedEmployee}
      getOptionValue={(option) => option._id}
      getOptionLabel={(option) =>
        option._id === "all"
          ? "All Employees"
          : `${option.firstName} ${option.lastName}`
      }
    />
  );
};

export default EmployeeSelect;
